import styled from '@emotion/styled';
import { Text as DSText } from 'ds/components/typography';

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: theme.spacing(2),
  gap: theme.spacing(2),
}));

export const ToggleRoot = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: theme.spacing(2),
}));

export const Text = styled(DSText.withComponent('h2'))(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const ToggleBtn = styled.div(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  color: theme.colors.brand.main,
  '::before': {
    display: 'block',
    content: '""',
    position: 'absolute',
    top: '-35px',
    height: '35px',
    right: 0,
    left: 0,
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)',
  },
  '> svg': {
    display: 'block',
    'path': {
      fill: theme.colors.brand.main,
    },
  },
}));

export const DescriptionText = styled(DSText.withComponent('p'))`
  white-space: pre-line;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;
